import React from 'react'
import styled from 'styled-components'

const FilesListElement = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 0 !important;
`

const FileItemElement = styled.li`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`

const FileItemLabelElement = styled.a`
  cursor: pointer;
  user-select: none;
  font-size: 0.9rem;
  font-weight: 200;
  color: #2e8ab8;
  user-select: none;
  margin: 0;
  margin-bottom: 0 !important;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

const FileItemInputElement = styled.input`
  width: 0.7rem;
  transform: scale(1.2);
  opacity: 0.9;
`

function Files({ files, fileUuidsToSign, handleFileUuidsToSignChange }) {
  const handleFileToggle = (uuid) =>
    handleFileUuidsToSignChange(
      fileUuidsToSign.includes(uuid)
        ? fileUuidsToSign.filter((fileUuid) => fileUuid !== uuid)
        : [...fileUuidsToSign, uuid]
    )

  return (
    <FilesListElement>
      {files.map(({ trimmedFilename: filename, uuid: fileUuid, fileUrl }) => (
        <FileItemElement key={fileUuid}>
          <FileItemInputElement
            type="checkbox"
            id={`file-${fileUuid}`}
            checked={fileUuidsToSign.includes(fileUuid)}
            onChange={() => handleFileToggle(fileUuid)}
          />
          <FileItemLabelElement target="_blank" href={fileUrl}>
            {filename}
          </FileItemLabelElement>
        </FileItemElement>
      ))}
    </FilesListElement>
  )
}

export default Files
